module.exports = __webpack_public_path__ + "static/img/1.0855a72.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/1.png
// module id = m8Du
// module chunks = 0